import { getFullTime } from "../lib/dateFormater"
import fetchService from "../lib/fetchService"
import { IMeeting, ISession } from "../lib/globalInterfaces"
import { SessionDTO } from "./SessionDTO"

export class WeekendDTO {

  sessions: SessionDTO[] = []

  meeting_key: number = -1
  circuit_key: number = -1
  circuit_short_name: string = ''
  meeting_code: string = ''
  location: string = ''
  country_key: number = -1
  country_code: string = ''
  country_name: string = ''
  meeting_name: string = ''
  meeting_official_name: string = ''
  gmt_offset: string = ''
  date_start: Date = new Date()
  year: number = -1
  
  constructor(data: IMeeting) {
    this.init(data)
  }

  public init(data: IMeeting) {
    this.meeting_key = data.meeting_key || -1
    this.circuit_key = data.circuit_key || -1
    this.circuit_short_name = data.circuit_short_name || ''
    this.meeting_code = data.meeting_code || ''
    this.location = data.location || ''
    this.country_key = data.country_key || -1
    this.country_code = data.country_code || ''
    this.country_name = data.country_name || ''
    this.meeting_name = data.meeting_name || ''
    this.meeting_official_name = data.meeting_official_name || ''
    this.gmt_offset = data.gmt_offset || ''
    this.date_start = data.date_start ? new Date(data.date_start) : new Date()
    this.year = typeof data.year === 'string' ? parseInt(data.year) : data.year || -1
  }

  async load(circuit_short_name?: string) {
    if (circuit_short_name) {
      this.circuit_short_name = circuit_short_name
    }
    const data: IMeeting[] = await fetchService.get('/api/season/' + this.year + '/' + circuit_short_name)
    this.init(data[0])
    await this.loadSessions()
  }

  async loadSessions() {
    const data: ISession[] = await fetchService.get('/api/session/' + this.meeting_key)
    this.sessions = data.map(item => new SessionDTO(item))
  }

  getDisplayName() {
    return this.meeting_name
  }

  getLink() {
    return `/${this.year}/${this.circuit_short_name}`
  }

  getHumanDate() {
    const date = new Date(this.date_start)
    return date.toLocaleDateString('de-DE', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
  }

  getFullTime() {
    return getFullTime(this.date_start, this.gmt_offset)
  }
}
